<div class="row main-content">
    <div class="w15">
        <div class="sidebar">
            <ul>
                <li *ngIf="checkOVRInAgencyCode==='false'" class="active"  routerLink="/dashboard/sales-home"><img src="./assets/images/home.svg"><a>Home</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'" (click)="goToQuotePurchase()" [ngClass]="{'op5': hideQuotePurchase==='true' || agentIdActive=='false' || isDisabled}"><img src="./assets/images/quotePurchase.svg"><a>QUOTE / PURCHASE</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'"  routerLink="/dashboard/policy-search"><img src="./assets/images/policySearch.svg"><a>POLICY SEARCH</a></li>
                <li *ngIf="checkOVRInAgencyCode==='false'"  (click)="goToSaveQuote()" [ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/home.svg"><a>SAVED QUOTES</a></li>
                <!-- <li routerLink="/dashboard/Groups"><img src="./assets/images/home.svg"><a>GROUPS</a></li> -->
                <li   (click)="goToforms()" [ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/file-text.svg" ><a>POLICY DOCUMENTS</a></li>
                <!-- <li routerLink="/dashboard/agency-admin"><img src="./assets/images/archive.svg"><a>AGENCY ADMIN</a></li> -->
                <li routerLink="/dashboard/sales-report"><img src="./assets/images/pie-chart.svg"><a>REPORTS</a></li>
                <li  (click)="goToResources()" [ngClass]="{'op5': agentIdActive==='false'}"><img src="./assets/images/resources.svg" ><a>RESOURCES</a></li>
            </ul>
        </div>
    </div>
    <div class="w85">
        <div *ngIf="showHome">
        <div class="row topWhiteBox">
            <div class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10">
                <label class="bold fs-18 txt-black">Policies Starting and Expiring</label>
            </div>
            <!-- <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-2 text-right">
                <div class="row myDIV1">
                    <div class="col-sm-10 col-md-10 col-lg-10 col-xl-10 col-10">
                        <label class="regular fs-12 txt-grey1 m-0">Change Date Rage</label><br>
                        <label class="semi-bold fs-12 txt-black m-0">7 days</label>
                    </div>
                    <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-2">
                        <div class="p-3 d-flex flex-row align-items-center">
                            <div class="d-flex flex-column ml-2">
                                <i class="fa fa-caret-down"></i>
                            </div>
                        </div>
                    </div>
                    <div class=" hide1">
                        <ul id="select_date">
                            <li><a>Last 7 Days</a></li>
                            <li><a>Last 14 Days</a></li>
                            <li><a>Last 30 Days</a></li>
                            <li><a>2020</a></li>
                            <li><a>2019</a></li>
                            <li><a>Custom</a></li>
                        </ul>
                    </div>
                </div>
            </div> -->
        </div>
        <div class="clear10"></div>
        <div class="p-2">
            <div class="row">
                <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-5">
                    <label class="semi-bold fs-14 txt-black m-0">Choose your date range</label>
                </div>
                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6">
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-4">
                            <label class="regular fs-14 txt-black m-0">Start Date</label>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-4">
                            <label class="regular fs-14 txt-black m-0">End Date</label>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-4">
                        </div>
                    </div>
                </div>
            </div>
            <div class="clear10"></div>
            <div class="row">
                <div class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-5">
                    <div class="row">
                        <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3 text-center">
                            <button type="button" class="fs-16 bold" [ngClass]="selectedButton == 'Active'?'addbtn':'daysBtn'"  (click)="getSearchPolicy($event)">7 DAYS</button>
                        </div>
                        <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3 text-center">
                            <button type="button" class="fs-16 bold" [ngClass]="selectedButton1 == 'Active'?'addbtn':'daysBtn'" (click)="getSearchPolicy14Days()">14 DAYS</button>
                        </div>
                        <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3 text-center">
                            <button type="button" class="fs-16 bold" [ngClass]="selectedButton2 == 'Active'?'addbtn':'daysBtn'" (click)="getSearchPolicy30Days()">30 DAYS</button>
                        </div>
                        <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-3 text-center">
                            <label class="semi-bold fs-14 txt-black m-0">OR</label>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-6">
                    <div class="row">
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-4">
                            <!-- <input class="form-control forminput mr-1" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt1" [owlDateTime]="dt1" [(ngModel)]="effectiveStartDate">
                            <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time> -->
                            <div class="home-datepicker mr-2">
                                <mat-form-field appearance="fill">
                                    <input matInput [matDatepicker]="datepicker1" placeholder="ddMMMyyyy" [(ngModel)]="effectiveStartDate" (dateChange)="callEffectiveStartDate()">
                                    <mat-datepicker-toggle matSuffix [for]="datepicker1"></mat-datepicker-toggle>
                                    <mat-datepicker #datepicker1></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-4">
                            <!-- <input class="form-control forminput ml-1" placeholder="MM-DD-YYYY" [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2" [(ngModel)]="effectiveEndDate" (ngModelChange)="getSearchPolicy($event)">
                            <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time> -->
                            <div class="home-datepicker">
                                <mat-form-field appearance="fill">
                                    <input matInput [matDatepicker]="datepicker2" placeholder="ddMMMyyyy" [(ngModel)]="effectiveEndDate" (dateChange)="callEffectiveEndDate()">
                                    <mat-datepicker-toggle matSuffix [for]="datepicker2"></mat-datepicker-toggle>
                                    <mat-datepicker #datepicker2></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-4">
                            <button type="button" class="fs-16 bold addbtn ml-3" (click)="getSearchPolicyManual()">Search</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="clear10"></div>
        <div class="row policywhiteBox">
            <label class="semi-bold fs-14 txt-black m-0" *ngIf="effectivePolicyListTotal==0">{{effectivePolicyListTotal}} Policy will become effective</label>
            <label class="semi-bold fs-14 txt-black m-0" *ngIf="effectivePolicyListTotal==1">{{effectivePolicyListTotal}} Policy will become effective</label>
            <label class="semi-bold fs-14 txt-black m-0" *ngIf="effectivePolicyListTotal>1">{{effectivePolicyListTotal}} Policies will become effective</label>
            <!-- <label class="regular fs-14 txt-black m-0">&nbsp;within next 7 days ({{this.effectiveStartDate | date:'MM/dd/yyyy'}}-{{this.effectiveEndDate | date:'MM/dd/yyyy'}})</label> -->
            <label class="regular fs-14 txt-black m-0">&nbsp;between {{this.effectiveStartDate | date:'dd MMM yyyy'}} and {{this.effectiveEndDate | date:'dd MMM yyyy'}}</label>

        </div>
        <div class="tableheadFix">
            <table id="LinkToLead" class="w100">
                <thead class="nowrap">
                    <tr>
                        <th>
                            <div class="d-flex flex-row align-items-center">
                                <span>POLICY</span>
                                <div class="d-flex flex-column ml-4">
                                    <i class="fa fa-caret-up"></i>
                                    <i class="fa fa-caret-down"></i>
                                </div>
                            </div>
                        </th>
                        <th>
                            <div class="d-flex flex-row align-items-center">
                                <span>DAYS UNTIL EFFECTIVE</span>
                                <div class="d-flex flex-column ml-4">
                                    <i class="fa fa-caret-up"></i>
                                    <i class="fa fa-caret-down"></i>
                                </div>
                            </div>
                        </th>
                        <th>
                            <div class="d-flex flex-row align-items-center">
                                <span>EFFECTIVE DATE</span>
                                <div class="d-flex flex-column ml-4">
                                    <i class="fa fa-caret-up"></i>
                                    <i class="fa fa-caret-down"></i>
                                </div>
                            </div>
                        </th>
                        <th>
                            <div class="d-flex flex-row align-items-center">
                                <span>INSURED</span>
                                <div class="d-flex flex-column ml-4">
                                    <i class="fa fa-caret-up"></i>
                                    <i class="fa fa-caret-down"></i>
                                </div>
                            </div>
                        </th>
                        <th>
                            <div class="d-flex flex-row align-items-center">
                                <span>PLAN</span>
                                <div class="d-flex flex-column ml-4">
                                    <i class="fa fa-caret-up"></i>
                                    <i class="fa fa-caret-down"></i>
                                </div>
                            </div>
                        </th>
                        <th>
                            <div class="d-flex flex-row align-items-center">
                                <span>TRAVEL DATES</span>
                                <div class="d-flex flex-column ml-4">
                                    <i class="fa fa-caret-up"></i>
                                    <i class="fa fa-caret-down"></i>
                                </div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody class="">
                    <tr *ngFor="let item of effectivePolicyList">
                        <td><span class="link cp" (click)="onClickPolicyNumber(item.id,item.policyNumber)">{{item.policyNumber}}</span></td>
                        <td><span class="red">{{item.effectiveDays}}</span></td>
                        <td>{{item.effectiveDate | date:'dd MMM yyyy'}}</td>
                        <td >
                            <div *ngFor="let data of item.policyInsureds">{{data.firstName}} {{data.lastName}}</div></td>
                        <td>{{item.plans.planName}}</td>
                        <td>{{item.effectiveDate | date:'dd MMM yyyy'}}-{{item.expiryDate | date:'dd MMM yyyy'}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row policywhiteBox">
            <label class="semi-bold fs-14 txt-black m-0" *ngIf="expirePolicyListTotal==0">{{expirePolicyListTotal}} Policy will be<span class="red"> expiring</span></label>
            <label class="semi-bold fs-14 txt-black m-0" *ngIf="expirePolicyListTotal==1">{{expirePolicyListTotal}} Policy will be<span class="red"> expiring</span></label>
            <label class="semi-bold fs-14 txt-black m-0" *ngIf="expirePolicyListTotal>1">{{expirePolicyListTotal}} Policies will be<span class="red"> expiring</span></label>
            <label class="regular fs-14 txt-black m-0">&nbsp;between {{this.effectiveStartDate | date:'dd MMM yyyy'}} and {{this.effectiveEndDate | date:'dd MMM yyyy'}}</label>
        </div>
        <div class="tableheadFix">
            <table id="LinkToLead" class="w100">
                <thead class="nowrap">
                    <tr>
                        <th>
                            <div class="d-flex flex-row align-items-center">
                                <span>POLICY</span>
                                <div class="d-flex flex-column ml-4">
                                    <i class="fa fa-caret-up"></i>
                                    <i class="fa fa-caret-down"></i>
                                </div>
                            </div>
                        </th>
                        <th>
                            <div class="d-flex flex-row align-items-center">
                                <span>DAYS UNTIL EXPIRY</span>
                                <div class="d-flex flex-column ml-4">
                                    <i class="fa fa-caret-up"></i>
                                    <i class="fa fa-caret-down"></i>
                                </div>
                            </div>
                        </th>
                        <th>
                            <div class="d-flex flex-row align-items-center">
                                <span>EXPIRY DATE</span>
                                <div class="d-flex flex-column ml-4">
                                    <i class="fa fa-caret-up"></i>
                                    <i class="fa fa-caret-down"></i>
                                </div>
                            </div>
                        </th>
                        <th>
                            <div class="d-flex flex-row align-items-center">
                                <span>INSURED</span>
                                <div class="d-flex flex-column ml-4">
                                    <i class="fa fa-caret-up"></i>
                                    <i class="fa fa-caret-down"></i>
                                </div>
                            </div>
                        </th>
                        <th>
                            <div class="d-flex flex-row align-items-center">
                                <span>PLAN</span>
                                <div class="d-flex flex-column ml-4">
                                    <i class="fa fa-caret-up"></i>
                                    <i class="fa fa-caret-down"></i>
                                </div>
                            </div>
                        </th>
                        <th>
                            <div class="d-flex flex-row align-items-center">
                                <span>TRAVEL DATES</span>
                                <div class="d-flex flex-column ml-4">
                                    <i class="fa fa-caret-up"></i>
                                    <i class="fa fa-caret-down"></i>
                                </div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody class="">
                    <tr *ngFor="let item of expirePolicyList">
                        <td><span class="link cp" (click)="onClickPolicyNumber(item.id,item.policyNumber)">{{item.policyNumber}}</span></td>
                        <td><span class="red">{{item.effectiveDays}}</span></td>
                        <td>{{item.expiryDate | date:'dd MMM yyyy'}}</td>
                        <td><div *ngFor="let data of item.policyInsureds">{{data.firstName}} {{data.lastName}}</div></td>
                        <td>{{item.plans.planName}}</td>
                        <td>{{item.effectiveDate | date:'dd MMM yyyy'}}-{{item.expiryDate | date:'dd MMM yyyy'}}</td>
                    </tr>
                   
                </tbody>
            </table>
        </div>
    </div>
        <div *ngIf="showPolicyDetails || showRefundPolicy">
            <div class="whitebox p-3">
                <label class="bold fs-18 m-0 cp" (click)="backToPolicySearch()">Policy Search</label>
                <label class="bold fs-20 red5 m-0">&nbsp;&nbsp;>&nbsp;&nbsp;</label>
                <label class="bold fs-18 txt-black m-0 cp" >TAG1153</label>
                <label class="bold fs-20 red5 m-0" *ngIf="showRefundPolicy">&nbsp;&nbsp;>&nbsp;&nbsp;</label>
                <label class="bold fs-18 red5 m-0" *ngIf="showRefundPolicy" >Refund Policy</label>
            </div>
            <div *ngIf="showPolicyDetails">
                <div class="p-3">
                    <button type="button" class="btns red5" (click)="onClickRefundPolicy()">Refund Policy</button>
                    <button type="button" class="btns txt-blue3">Change Policy</button>
                    <!-- <button type="button" class="btns green" >Clone Policy</button> -->
                    <button type="button" class="btns txt-lightblack2">View/Print/Email</button>
                </div>
                <div class="border-bottom"></div>
                <div class="p-3">
                    <div class="whitebox1">
                        <label class="bold fs-16 red5 m-0">Policy Basics:</label>
                        <label class="bold fs-16 green m-0">&nbsp;&nbsp;Active</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Agent</label>
                                <div class="bold fs-14 purple">tst - test test</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Departure</label>
                                <div class="bold fs-14 purple">Vancouver</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Destination</label>
                                <div class="bold fs-14 purple">Canada</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Ref Num</label>
                                <div class="bold fs-14 purple">234567</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Beneficiary</label>
                                <div class="bold fs-14 purple">Belgium</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Total Admin Fee</label>
                                <div class="bold fs-14 purple">$0.00</div>
                            </div>
                        </div>
                        <div class="clear10"></div>
                        <div class="row">
                            <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                                <label class="regular fs-14 txt-lightblack2">Total Premium</label>
                                <div class="bold fs-14 purple">$27.72 ($27.72 + $0.00 tax) 8.32c</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1">
                        <label class="bold fs-16 red5 m-0">Policy Dates</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Effective</label>
                                <div class="bold fs-14 purple">04/15/2022</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Expiry</label>
                                <div class="bold fs-14 purple">04/15/2022</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Days</label>
                                <div class="bold fs-14 purple">11</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Application</label>
                                <div class="bold fs-14 purple">04/15/2022</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1">
                        <label class="bold fs-16 red5 m-0">Contact Information</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Name</label>
                                <div class="bold fs-14 purple">tst - test test</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Address</label>
                                <div class="bold fs-14 purple">Canada</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Email</label>
                                <div class="bold fs-14 purple">xyz@xyz.com</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Day Phone</label>
                                <div class="bold fs-14 purple">(N/A)</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Night Phone</label>
                                <div class="bold fs-14 purple">(N/A)</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Language</label>
                                <div class="bold fs-14 purple">English</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1">
                        <label class="bold fs-16 red5 m-0">Plan:</label>
                        <label class="bold fs-16 red5 m-0">&nbsp;&nbsp;Visitors To Canada Premier Plan</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Total</label>
                                <div class="bold fs-14 purple">$25,000</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Insured</label>
                                <div class="bold fs-14 purple">Dummy</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Insured Amt.</label>
                                <div class="bold fs-14 purple">$25,000</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Arrival Date</label>
                                <div class="bold fs-14 purple">04/17/2022</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Days</label>
                                <div class="bold fs-14 purple">11</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Option</label>
                                <div class="bold fs-14 purple">Dummy</div>
                            </div>
                        </div>
                        <div class="clear10"></div>
                        <div class="row">
                            <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 col-12">
                                <label class="regular fs-14 txt-lightblack2">Option</label>
                                <div class="bold fs-14 purple">Wait Periodc</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1">
                        <label class="bold fs-16 red5 m-0">Payments</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Date</label>
                                <div class="bold fs-14 purple">04/15/2022</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Type</label>
                                <div class="bold fs-14 purple">Cheque</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Payment Amount</label>
                                <div class="bold fs-14 purple">$11</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Admin Fee</label>
                                <div class="bold fs-14 purple">$00</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Card Number</label>
                                <div class="bold fs-14 purple">04152022</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">EXp</label>
                                <div class="bold fs-14 purple">04/15/2022</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1">
                        <label class="bold fs-16 red5 m-0">Other Info</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Doc Name</label>
                                <div class="bold fs-14 purple">DocName.txt</div>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <label class="regular fs-14 txt-lightblack2">Doc Name</label>
                                <div class="bold fs-14 purple">DocName.txt</div>
                            </div>
                        </div>
                    </div>
                    <div class="clear20"></div>
                    <div class="whitebox1">
                        <label class="bold fs-16 red5 m-0">Fulfillment</label>
                        <div class="clear5"></div>
                        <div class="border-bottom"></div>
                        <div class="clear5"></div>
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-xl-2 col-12">
                                <div class="bold fs-14 purple">04/15/2022</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="showRefundPolicy" class="p-3">
                <label class="bold fs-16 txt-black">REFUND POLICY</label>
                <div class="clear5"></div>
                <div class="border-bottom"></div>
                <div class="clear10"></div>
                <label class="regular fs-16 txt-lightgrey">Please enter reason for refund</label>
                <div class="row">
                    <textarea rows=4 class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-12"></textarea>
                </div>
                <div class="clear10"></div>
                <button type="button" class="btn-upload">Process Refund</button>
                <div class="clear10"></div>
                <div class="border-bottom"></div>
                <div class="clear10"></div>
                <label class="bold fs-16 txt-black">PAYMENTS TO BE REFUNDED</label>
                <div class="clear10"></div>
                <div class="tableheadFix">
                    <table id="RefundPolicy" class="w100">
                        <thead class="nowrap">
                            <tr>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>DATE</span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>TYPE</span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>PAYMENT AMOUNT</span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>ADMIN FEE</span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>CARD NUMBER</span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-flex flex-row align-items-center">
                                        <span>EXP (MMYY)</span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody class="">
                            <tr>
                                <td><span>03/22/2022</span></td>
                                <td>Cheque</td>
                                <td>$46</td>
                                <td>$0.00</td>
                                <td>03022022</td>
                                <td>02/2022</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
